export const formatToCurrency = (val: number) => {
  if (!val) return val;
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(val);
};
